// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import UUID from 'vue-uuid'
import VueJwtDecode from 'vue-jwt-decode';
import VueHotkey from "v-hotkey"

import loadFilters from './filters'

import './plugins/chartjs'

Vue.use(UUID);
Vue.use(VueJwtDecode);
Vue.use(VueHotkey);

Vue.config.productionTip = false

Vue.component('CustomIcon', require('./components/shared/customIcon').default)
Vue.component('NumberIcon', require('./components/shared/numberIcon').default)
Vue.component('ExpediteTruck', require('./components/shared/expediteTruck').default)

loadFilters()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js